import { combineReducers } from "redux";
import { userReducer } from "./index";

export const userCreateReducer = (asyncReducers) =>
  combineReducers({
    ...asyncReducers,
    userReducer,
  });
